import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        ritual: 'Tea Ritual',
        shop: 'Shop',
        about: 'About',
        journal: 'Journal',
        account: 'My Ritual'
      },
      hero: {
        eyebrow: 'Doctor-curated wellness club',
        title: 'Tiger Ritual: Your daily tea ritual begins here.',
        subtitle: 'Answer a few questions and receive a personalized tea blend for sleep, focus, gut, desire, calm, or breathing.',
        ctaPrimary: 'Start your tea ritual',
        ctaSecondary: 'Shop all blends'
      },
      howItWorks: {
        title: 'How It Works',
        step1Title: 'Take the Quiz',
        step1Text: 'Tell us your wellness goals and body profile',
        step2Title: 'Get Your Ritual',
        step2Text: 'Receive doctor-curated tea recommendations',
        step3Title: 'Brew & Enjoy',
        step3Text: 'Experience your personalized wellness ritual'
      },
      categories: {
        title: 'Choose Your Tiger Ritual',
        sleep: 'Sleep Ritual',
        sleepDesc: 'For deep rest and slower evenings',
        desire: 'Desire Ritual',
        desireDesc: 'For energy, blood flow, and sensuality',
        focus: 'Focus Ritual',
        focusDesc: 'For clarity, productivity, and sharp mind',
        calm: 'Calm Ritual',
        calmDesc: 'For anxiety, stress, and emotional balance',
        gut: 'Gut Ritual',
        gutDesc: 'For digestion and lightness',
        breath: 'Breath Ritual',
        breathDesc: 'For lungs, throat, and immune support',
        skin: 'Skin Ritual',
        skinDesc: 'For radiance and inner beauty'
      },
      footer: {
        tagline: 'Doctor-curated tea rituals for everyday wellness',
        newsletter: 'Join our wellness community',
        newsletterPlaceholder: 'Enter your email',
        subscribe: 'Subscribe',
        links: 'Links',
        legal: 'Legal'
      }
    }
  },
  ko: {
    translation: {
      nav: {
        home: '홈',
        ritual: '티 리추얼',
        shop: '쇼핑',
        about: '소개',
        journal: '저널',
        account: '내 리추얼'
      },
      hero: {
        eyebrow: '의사가 선별한 웰니스 클럽',
        title: '타이거 리추얼: 당신의 일상 차 의식을 시작하세요.',
        subtitle: '몇 가지 질문에 답하고 수면, 집중력, 소화, 활력, 평온, 또는 호흡을 위한 맞춤 차 블렌드를 받으세요.',
        ctaPrimary: '차 리추얼 시작하기',
        ctaSecondary: '모든 블렌드 보기'
      },
      howItWorks: {
        title: '이용 방법',
        step1Title: '퀴즈 받기',
        step1Text: '웰니스 목표와 체질 알려주기',
        step2Title: '리추얼 받기',
        step2Text: '의사가 선별한 차 추천받기',
        step3Title: '우리고 즐기기',
        step3Text: '맞춤 웰니스 의식 경험하기'
      },
      categories: {
        title: '타이거 리추얼 선택하기',
        sleep: '수면 리추얼',
        sleepDesc: '깊은 휴식과 편안한 저녁을 위해',
        desire: '활력 리추얼',
        desireDesc: '에너지, 혈액 순환, 관능미를 위해',
        focus: '집중 리추얼',
        focusDesc: '명료함, 생산성, 예리한 정신을 위해',
        calm: '평온 리추얼',
        calmDesc: '불안, 스트레스, 감정 균형을 위해',
        gut: '소화 리추얼',
        gutDesc: '소화와 가벼움을 위해',
        breath: '호흡 리추얼',
        breathDesc: '폐, 목, 면역 지원을 위해',
        skin: '피부 리추얼',
        skinDesc: '광채와 내면의 아름다움을 위해'
      },
      footer: {
        tagline: '일상 웰니스를 위한 의사 선별 차 리추얼',
        newsletter: '웰니스 커뮤니티 가입',
        newsletterPlaceholder: '이메일을 입력하세요',
        subscribe: '구독하기',
        links: '링크',
        legal: '법적 고지'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;